export enum RequestAbortSignal {
  GeneratedReports = 'REPORT_BUILDER_GENERATED_REPORTS',
  ScheduledReports = 'REPORT_BUILDER_SCHEDULED_REPORTS',
  Templates = 'REPORT_BUILDER_TEMPLATES',
  Campaigns = 'REPORT_BUILDER_CAMPAIGNS',
  Events = 'REPORT_BUILDER_EVENTS',
}
